// extracted by mini-css-extract-plugin
export default {"AddAsset":"CarouselInput_AddAsset__JKTGu","Image":"CarouselInput_Image__uy90F"};